import { fetchWalletBalances } from '~/api/wallet'
import type { CurrencyBalanceDto } from '~/types/api/wallet'

/** 并发请求合并：多次 refresh 共享同一次拉取 */
let inflight: Promise<CurrencyBalanceDto> | null = null

/**
 * 钱包业务层：拉取余额并回填 user store。
 * store 只负责 setWallet / clearSession，请求放在 composable。
 */
export function useWallet() {
  const userStore = useUserStore()

  const refreshWallet = async () => {
    if (inflight) {
      console.debug('[auth] wallet refresh joined in-flight request')
      return inflight
    }

    inflight = fetchWalletBalances()
      .then(dto => {
        userStore.setWallet(dto)
        return dto
      })
      .finally(() => {
        inflight = null
      })

    return inflight
  }

  return { refreshWallet }
}
